import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpregistrywrite1patchPatchRegistryDefinitionsDefinitionKeyAnnotateResponseSchema = jsonObject
export type tcpregistrywrite1patchPatchRegistryDefinitionsDefinitionKeyAnnotateResponse = z.infer<typeof tcpregistrywrite1patchPatchRegistryDefinitionsDefinitionKeyAnnotateResponseSchema>
